// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"DisableEnquiryMessageBox_messageBox__U5_Sf"};